import { I18nextProvider, useTranslation } from 'react-i18next';
import { styled, Typography } from '@mui/material';
import React from 'react';
import { BlockContainer } from '../landingMain/BlockContainer';
import i18n from '../../components/i18n';
import { CASHBACK_WIZARD_START } from '../../src/helpers/urlConstants';
import { Header } from '../../components/Header/Header';
import { DetailCalculatorWithUrlChange } from './DetailCalculatorWithUrlChange';

const CalculatorBox = styled('div')(({ theme }) => ({
  border: 'solid 1px',
  borderRadius: '8px',
  borderColor: theme.palette.border.secondary,

  [theme.breakpoints.down('sm')]: {
    boxShadow: '0px 2px 4px -1px rgba(30, 39, 50, 0.16)',
  },
}));

const Headings = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header variant="h3" headerText={t('cashbackCalculator.title')} id="cashback-calculator" />
      <Header variant="h3" headerText={t('cashbackCalculator.subTitle')} />
      <Typography variant="subtitle2" color="textSecondary" mt={6}>
        {t('cashbackCalculator.subheading')}
      </Typography>
      <Typography variant="subtitle2" color="textSecondary">
        {t('cashbackCalculator.goodToKnow')}
      </Typography>
    </>
  );
};

export const OnvistaCashbackCalculator = () => {
  const bookNowUrl = `${CASHBACK_WIZARD_START}?mandator=onvista-cashback`;

  return (
    <div>
      <BlockContainer id="cashback-calculator-with-header" spacingBottom={1} spacingBottomXs={1}>
        <I18nextProvider i18n={i18n} defaultNS="onvista">
          <Headings />
        </I18nextProvider>
      </BlockContainer>

      <I18nextProvider i18n={i18n} defaultNS="onvista">
        <BlockContainer id="detail-calculator" spacingBottom={1} spacingBottomXs={1}>
          <CalculatorBox>
            <DetailCalculatorWithUrlChange model="80-percent" bookNowUrl={bookNowUrl} />
          </CalculatorBox>
        </BlockContainer>
      </I18nextProvider>
    </div>
  );
};
